export class CalendarScope {
  id: number;
  name: string;

  constructor(data) {
    this.id = (data.calendar_scope_id || data.calendar_scope_pk) ? parseInt((data.calendar_scope_id) ? data.calendar_scope_id : data.calendar_scope_pk) : null
    this.name = (data.name || data.description) ? (data.name) ? data.name : data.description : null
  }
}
